module.exports = __webpack_public_path__ + "static/media/banner-inner.23972567.png";